module.exports = __webpack_public_path__ + "img/header_bg.f46993ac.png";